import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import SigninForm from "./SigninForm";
import {AppContext} from "../utilities/context";
import LayoutMUI from "./Layout";
import { Navigate } from "react-router-dom";

function LoggedStatus(props) {
  const context = useContext(AppContext);
  if (context.user && context.user.id) return <Navigate to={"/account"} />;
  return <SigninForm />;
}

const Login = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([{ label: intl.formatMessage({ id: "app.header.home.label" }), url: "/" }]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

    return (
      <LayoutMUI>
        <LoggedStatus updateAppState={null} />
      </LayoutMUI>
    );
}

export default Login;